import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';
export const GET_ALL_COLORS = 'GET_ALL_COLORS';
export const SAVE_COLOR = 'SAVE_COLOR';
export const DELETE_COLOR = 'DELETE_COLOR';

const successColor = 'success';
const errorColor = 'danger';
//const warningColor = 'warning';

export function fetchAllColors() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageColors/GetColorOptions`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_ALL_COLORS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function saveColor(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageColors/SaveColor`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: SAVE_COLOR,
						payload: response.data.colors
					});
					var success = response && response.data ? response.data.message : 'Color Created Successfully';
					dispatch(toastr(true, success, successColor));
				} 
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deleteColor(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageColors/DeleteColor`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
				dispatch({
					type: DELETE_COLOR,
					payload: response.data.colors
				});
				var success = response && response.data ? response.data.message : 'Color Deleted Successfully';
					dispatch(toastr(true, success, successColor));
				} 
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}
